import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { exploreDare } from "./exploreDareApi";

const initialState = {
    status: "idle",
    NewQuestion:'',
    NewQuestionTimer: '',
    DrinkQuestion: '',
    Attributes: [],
    Accessories:[],
    UsedQuestionsId:[],
    LastCard: false,
}

export const exploreDareAsync = createAsyncThunk(
    "/exploredare",
    async ({gender, player},{getState, rejectWithValue}) => {
        try {
            const state = getState()
            const usedid = state.exploreDare.UsedQuestionsId
            const status = state.exploreDare.status
            const selectedaccessories = state.exploreDare.Accessories
            const sessionid = state.gameStatus.sessions['explore'].sessionId
            const response = await exploreDare(gender, player, usedid, selectedaccessories, sessionid);
            return response
        } catch (error) {
            console.error("Error in exploreDareAsync:", error); // 👀 This should appear now
            return rejectWithValue(error.response
             ? { data: error.response.data, status: error.response.status }
             : { data: { error: "Unknown error" }, status: 500 })
    }
    }
)

export const exploreDareSlice = createSlice({
    name: "exploredare",
    initialState,
    reducers: {
        setAccessories: (state, action) =>{
            state.Accessories = action.payload
        },
        resetState:(state) =>{
            state.status ="idle"
            state.NewQuestion = ''
            state.NewQuestionTimer = ''
            state.DrinkQuestion = ''
            state.Attributes = []
            state.Accessories = []
            state.UsedQuestionsId =[]
            state.LastCard = false;
        },
    },
    extraReducers:(builder) => {
        builder
            .addCase(exploreDareAsync.pending, (state) => {
                state.status = 'fetching';
            })
            .addCase(exploreDareAsync.fulfilled, (state, action)=>{
                state.status ="fulfilled";
                state.NewQuestion = action.payload.question
                state.NewQuestionTimer = action.payload.timer
                state.DrinkQuestion = action.payload.drink
                state.UsedQuestionsId = [...state.UsedQuestionsId,action.payload.id]
                state.Attributes = [action.payload.attributes]
                state.LastCard = action.payload.last_card || false;
            })}})

export const selectExploreDare = (state) => state.exploreDare
export const { setAccessories, resetState } = exploreDareSlice.actions;
export default exploreDareSlice.reducer